import React from "react";
import Modal from "../../components/Modals/Modal";
import SecondaryButton from "../../components/Buttons/SecondaryButton";
import PrimaryButton from "../../components/Buttons/PrimaryButton";

export default function RemoveTreatmentTransactionModal({
  removeTreatmentTransaction,
  showRemoveTransaction,
  setShowRemoveTransaction,
  treatmentId,
  selectedTransaction,
}) {
  const handleCancelRemoveTransaction = () => {
    setShowRemoveTransaction(false);
  };

  const handleRemoveTransaction = () => {
    removeTreatmentTransaction(treatmentId, selectedTransaction.id);
    setShowRemoveTransaction(false);
  };

  return (
    <Modal
      title={"Remove Treatment Transaction"}
      show={showRemoveTransaction}
      hide={handleCancelRemoveTransaction}
    >
      <div className="flex flex-col min-h-170">
        <span className="my-auto">
          Are you sure you want to remove this transaction?
        </span>
        <div className="grid grid-cols-2 gap-x-2 mt-auto">
          <SecondaryButton
            onClick={handleCancelRemoveTransaction}
            text="Cancel"
          />
          <PrimaryButton text={"Remove"} onClick={handleRemoveTransaction} />
        </div>
      </div>
    </Modal>
  );
}